import { render } from "./HomeParcelsView.vue?vue&type=template&id=3bd4e0be"
const script = {}

import "./HomeParcelsView.vue?vue&type=style&index=0&id=3bd4e0be&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__